<template>
    <div class="slide trivia-13">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="3"
                    :total="4"
                    :className="className" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-14",
            className: "trivia-13",
            currentTrivia: 13,
            questions: {
                question: {
                    "title": "Which of the following is an objective claim?",
                    "answers": [
                        {"key": "A", "answer": "The subject selected a cordless drill battery and concealed it under his jacket"},
                        {"key": "B", "answer": "The subject appeared nervous, while looking around in the aisle"},
                        {"key": "C", "answer": "I don't think the subject could not afford the merchandise that he selected"},
                        {"key": "D", "answer": "He must have been planning a theft because he was in the store a long time"}
                    ],
                    "correctAnswer": ["A"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss">
.trivia-13 {

    h1 {
        font-size: 27px !important;
        line-height: 1;
    }
}
</style>
